import { Account } from '@tcs/client-portal-api/types/Account';
import { useQuery } from '@tcs/common/hooks/useQuery';

interface Props {
  loading: boolean;
  data?: Account;
}

export const useAccount = (accountNumber?: string): Props => {
  const { data, isLoading: loading } = useQuery<Account, Error>(
    `/accounts/${accountNumber}`,
    {
      refetchOnMount: false,
      enabled: accountNumber !== undefined,
    }
  );

  return {
    loading,
    data,
  };
};

export default useAccount;
